import { HIDE_TOAST, SHOW_TOAST } from './action-types';
import { ToastName } from '../../types/ToastNames';

export const showToast = (toastName: ToastName, toastParams = {}) => {
  return {
    type: SHOW_TOAST,
    toastName,
    toastParams
  };
};

export const hideToastAction = () => ({
  type: HIDE_TOAST,
});
